import { render } from "./ClassSelectionWindow.vue?vue&type=template&id=074bf5fe&scoped=true"
import script from "./ClassSelectionWindow.vue?vue&type=script&lang=js"
export * from "./ClassSelectionWindow.vue?vue&type=script&lang=js"

import "./ClassSelectionWindow.vue?vue&type=style&index=0&id=074bf5fe&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-074bf5fe"]])

export default __exports__